import React from "react";
import Identity from "../settings/user/personal";

const Step5 = ({ settings, setStep, skipStep }) => {
	return (
		<div>
			<Identity setStep={setStep} skipStep={skipStep} />
		</div>
	)
}

export default Step5;
